<script lang="ts" setup>
defineProps<{
  deviation: string
  type: 'missing' | 'unwanted'
}>()
</script>

<template>
  <span :class="`deviation-${type}`" class="deviation">
    {{ $t('step_system_schemes.deviation_' + deviation) }}
  </span>
</template>

<style lang="scss" scoped>
.deviation {
  padding: 0.25rem 0.725rem;
  font-size: 0.75rem;

  @include themify($themes) {
    border-radius: rem-calc(themed('inputBorderRadius'));
  }

  &-missing {
    background: $deviationMissingBgColor;
    color: $deviationMissingTextColor;
  }

  &-unwanted {
    background: $deviationUnwantedBgColor;
    color: $deviationUnwantedTextColor;
  }
}
</style>
